export const SET_ORGANIZATIONS = 'SET_ORGANIZATIONS';
export const SELECTED_ORGANIZATION = 'SELECTED_ORGANIZATION';
export const LOADING_START = 'LOADING_START';
export const LOADING_DONE = 'LOADING_DONE';
